import PropTypes from "prop-types";

ChallengeResults.propTypes = {
  results: PropTypes.object.isRequired,
  challenge: PropTypes.object.isRequired
};

function calculateScore(results, challenge) {
  return Math.round((results.correct / challenge.questions.length) * 100);
}

export default function ChallengeResults ( {results, challenge} ) {

  return (
    <div className="challenge-results">
      <p className="challenge-results-score">
        Your score: {calculateScore(results, challenge)}%
      </p>

      {results.answers.length > 0 && <table className="challenge-results-table">
        <thead>
        <tr>
          <th>#</th>
          <th>Question</th>
          <th>Your answer</th>
          <th>Correct</th>
        </tr>
        </thead>
        <tbody>
        {results.answers.map((answer, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{
              answer.question.map((line, index) => (
                <p key={index} className="challenge-results-table-text">{line}</p>
              ))
            }</td>
            <td>{answer.selected}</td>
            <td>{answer.correct ? '✔' : '❌'}</td>
          </tr>
        ))}
        </tbody>
      </table>
      }
    </div>
  )
}